import * as React from 'react';
import { useDataGridBody_unstable as useDataGridBodyBase_unstable, TableRowIdContextProvider } from '@fluentui/react-table';
import { TableRowIndexContextProvider } from '../../contexts/rowIndexContext';
/**
 * Create the state required to render DataGridBody.
 *
 * The returned state can be modified with hooks such as useDataGridBodyStyles_unstable,
 * before being passed to renderDataGridBody_unstable.
 *
 * @param props - props from this instance of DataGridBody
 * @param ref - reference to root HTMLElement of DataGridBody
 */ export const useDataGridBody_unstable = (props, ref)=>{
    const { height , itemSize , width ='100%' , ariaRowIndexStart =2 , children  } = props;
    // cast the row render function to work with unknown args
    const renderRowWithUnknown = children;
    const baseState = useDataGridBodyBase_unstable({
        ...props,
        children: renderRowWithUnknown
    }, ref);
    const virtualizedRow = React.useCallback(({ data , index , style  })=>{
        const row = data[index];
        return /*#__PURE__*/ React.createElement(TableRowIndexContextProvider, {
            value: ariaRowIndexStart + index
        }, /*#__PURE__*/ React.createElement(TableRowIdContextProvider, {
            value: row.rowId
        }, children(row, style)));
    }, [
        ariaRowIndexStart,
        children
    ]);
    return {
        ...baseState,
        itemSize,
        height,
        virtualizedRow,
        width,
        ariaRowIndexStart
    };
};
